import React from 'react';
import Header from '../components/Header';
import Banner from '../components/Banner';
import AboutUs from '../components/AboutUs';
import Gallery from '../components/Gallery';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />
      <Banner />
      <AboutUs />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
